import { useTranslation } from 'react-i18next'

import { AnimatePresence, motion } from 'motion/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SummaryLineItem = ({ item }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{
          duration: 0.4,
        }}
      >
        <Text type="allCapsM" color={theme.colors.text.subtle}>
          {t('Producto')} #{item.originalIndex}
        </Text>
        <Styles.ProductNameUl>
          <li>
            <Text type="bodyMRegular">{item.name}</Text>
          </li>
        </Styles.ProductNameUl>
      </motion.div>
    </AnimatePresence>
  )
}

export default SummaryLineItem
